"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _utils = require("../../utils/utils");
var _constants = require("../../constants/constants");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Embedded checkout overlay (Shopify).
 *
 * The embedded checkout reuses the mandate create-cart flow: the redirect-info widget creates the
 * cart, builds the returnUrl, and produces the /checkout-page URL. For the embedded experience that
 * navigation is intercepted (see BwaRedirectInfoWidgetRenderHandler) and dispatched here as a
 * BWA_EMBEDDED_CHECKOUT_TRIGGER carrying the ready-to-load URL, which we open in a full-page iframe
 * overlay. The checkout page redirects to the login page itself when the shopper has no
 * token, then continues to address selection.
 *
 * On completion the iframe posts BWA_EMBEDDED_CHECKOUT_COMPLETE with the returnUrl; we navigate the
 * storefront there (which routes on to the Shopify checkout). There is no store-login here, so we
 * do not set ap_return.
 */
var BwaEmbeddedCheckoutRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaEmbeddedCheckoutRenderHandler() {
    var _this;
    (0, _classCallCheck2["default"])(this, BwaEmbeddedCheckoutRenderHandler);
    _this = _callSuper(this, BwaEmbeddedCheckoutRenderHandler);
    _this.bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handlePopState = _this.handlePopState.bind(_this);
    _this.historyTrapArmed = false;
    return _this;
  }
  (0, _inherits2["default"])(BwaEmbeddedCheckoutRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaEmbeddedCheckoutRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setupTriggerListener();
              this.setupMessageListeners();
              // The continue/complete path navigates the storefront to the Shopify checkout. If the user
              // then presses Back, the storefront can be restored from the bfcache with our modal still
              // open. Tear it down on the way out (pagehide) and on bfcache restore (pageshow.persisted) so
              // Back lands on the real page, not a stale overlay.
              window.addEventListener("pagehide", function () {
                return _this2.removeEmbeddedCheckoutWidget();
              });
              window.addEventListener("pageshow", function (event) {
                if (event.persisted) _this2.removeEmbeddedCheckoutWidget();
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "setupTriggerListener",
    value: function setupTriggerListener() {
      var _this3 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_TRIGGER, function (event) {
        var url = event.detail && event.detail.url;
        if (!url) return;
        _this3.injectEmbeddedCheckoutWidget(url);
      });
    }
  }, {
    key: "setupMessageListeners",
    value: function setupMessageListeners() {
      var _this4 = this;
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data;
        if (event.origin !== _this4.bwaOrigin) return;
        switch ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) {
          case _constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_COMPLETE:
            _this4.cancelOtpAutofill();
            // Keep the overlay up as a cover so the hand-off to the Shopify checkout is
            // seamless (no flash of the bare storefront between close and navigate). The
            // overlay is torn down by the pagehide handler as this page unloads, and by
            // pageshow(persisted) if the shopper later returns via Back (bfcache restore).
            if (event.data.returnUrl) {
              window.location.href = event.data.returnUrl;
            } else {
              window.location.reload();
            }
            break;
          case _constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_DISMISS:
            _this4.dismiss();
            break;

          // WebOTP relay: the cognito OTP page (cross-origin iframe) can't read the SMS itself
          // because the OTP "@<domain>" binds to THIS store origin. Read it here and relay the
          // code back to the iframe that asked (event.source), scoped to the BwA origin.
          case _constants.EVENT_TYPE.CUSTOM.BWA_OTP_AUTOFILL_ARM:
            _this4.armOtpAutofill(event.source);
            break;
          case _constants.EVENT_TYPE.CUSTOM.BWA_OTP_AUTOFILL_CANCEL:
            _this4.cancelOtpAutofill();
            break;
        }
      });
    }
  }, {
    key: "injectEmbeddedCheckoutWidget",
    value: function injectEmbeddedCheckoutWidget(url) {
      var _this5 = this;
      var existing = (0, _utils.safeGetElementById)(_constants.BWA_WIDGET_CONTAINER_IDS.BWA_EMBEDDED_CHECKOUT_CONTAINER_ID);
      if (existing) existing.remove();

      // <dialog> + showModal() renders in the browser top layer, above top-layer theme cart
      // drawers/popovers (which z-index alone can't beat).
      var container = document.createElement("dialog");
      container.id = _constants.BWA_WIDGET_CONTAINER_IDS.BWA_EMBEDDED_CHECKOUT_CONTAINER_ID;
      container.className = _constants.CSS_CLASSES.EMBEDDED_CHECKOUT_CONTAINER;
      var sheet = document.createElement("div");
      sheet.className = "bwa-embedded-checkout-sheet";
      var spinner = document.createElement("div");
      spinner.className = "bwa-embedded-checkout-spinner";
      sheet.appendChild(spinner);
      container.appendChild(sheet);
      var iframe = (0, _utils.generateIframe)(_constants.IFRAME_IDS.EMBEDDED_CHECKOUT, _constants.CSS_CLASSES.EMBEDDED_CHECKOUT, url);
      iframe.title = "BwA Checkout";
      iframe.style.opacity = "0";
      iframe.addEventListener("load", function () {
        var loadingSheet = container.querySelector(".bwa-embedded-checkout-sheet");
        if (loadingSheet) loadingSheet.remove();
        iframe.style.opacity = "1";
      });
      container.appendChild(iframe);
      this.iframe = iframe;

      // Backdrop click / Escape / Android hardware-back route to the iframe as a back-intent
      // (header-back parity) instead of closing the overlay outright.
      container.addEventListener("click", function (event) {
        if (event.target === container) {
          _this5.sendBackIntent();
        }
      });
      // Escape on a modal <dialog> fires 'cancel'; preventDefault keeps the overlay open while the
      // iframe handles the back-intent (otherwise the dialog would close itself and skip the popup).
      container.addEventListener("cancel", function (event) {
        event.preventDefault();
        _this5.sendBackIntent();
      });
      document.body.appendChild(container);
      // Promote to the top layer. Fallback to a visible non-modal dialog (relies on z-index) if
      // showModal is unavailable or throws — note a <dialog> without [open] is display:none, so the
      // fallback MUST set open so the overlay still renders.
      if (typeof container.showModal === "function") {
        try {
          container.showModal();
        } catch (e) {
          container.open = true;
        }
      } else {
        container.open = true;
      }
      document.body.classList.add("bwa-no-scroll");
      document.addEventListener("keydown", this.handleKeyDown);
      this.armHistoryBackTrap();
    }

    // Android hardware-back closes a modal <dialog> even when the 'cancel' event is preventDefault-ed,
    // which would exit the checkout outright. Push a history sentinel so hardware/browser back is
    // consumed as a popstate BEFORE the dialog closes; we then run the current screen's back behavior
    // (parity with the header back button) and re-arm the sentinel. Desktop Esc/backdrop still route
    // through 'cancel'/click. Falls back silently to the dialog 'cancel' path if history is unavailable.
  }, {
    key: "armHistoryBackTrap",
    value: function armHistoryBackTrap() {
      if (this.historyTrapArmed) return;
      try {
        window.history.pushState({
          bwaEmbeddedCheckout: true
        }, "");
        window.addEventListener("popstate", this.handlePopState);
        this.historyTrapArmed = true;
      } catch (e) {
        /* history unavailable — rely on the <dialog> cancel handler */
      }
    }
  }, {
    key: "handlePopState",
    value: function handlePopState() {
      // Overlay already gone (dismissed/handed off): let the back proceed normally.
      if (!this.iframe) return;
      // Re-arm the sentinel so the next back is caught too, then ask the embedded page what to do.
      try {
        window.history.pushState({
          bwaEmbeddedCheckout: true
        }, "");
      } catch (e) {/* no-op */}
      this.sendBackIntent();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.key === "Escape") {
        this.sendBackIntent();
      }
    }

    // Ask the embedded page to run its current screen's back behavior (header-back parity), rather than
    // closing the overlay from the parent. The iframe shows the friction popup / goes back to the phone
    // screen / posts bwa-embedded-checkout-dismiss (which we handle in setupMessageListeners) as needed.
  }, {
    key: "sendBackIntent",
    value: function sendBackIntent() {
      if (this.iframe && this.iframe.contentWindow) {
        this.iframe.contentWindow.postMessage({
          type: _constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_BACK_INTENT
        }, this.bwaOrigin);
      } else {
        // No iframe to consult — fall back to a straight dismiss.
        this.dismiss();
      }
    }

    // Read the SMS OTP on behalf of the cross-origin OTP iframe (WebOTP binds "@<domain>" to THIS
    // store origin) and relay the code back, scoped to the BwA origin. No-ops on iOS/desktop.
    // TODO: unreliable for non-Gboard users — some Android keyboards / SMS apps never surface the
    // OTPCredential, so autofill silently doesn't fire. Needs debugging; manual entry is the fallback.
  }, {
    key: "armOtpAutofill",
    value: function armOtpAutofill(source) {
      var _this6 = this;
      if (!("OTPCredential" in window) || typeof AbortController === "undefined" || !source) return;
      this.cancelOtpAutofill();
      this.otpAbortController = new AbortController();
      navigator.credentials.get({
        otp: {
          transport: ["sms"]
        },
        signal: this.otpAbortController.signal
      }).then(function (cred) {
        if (cred && cred.code) {
          source.postMessage({
            type: _constants.EVENT_TYPE.CUSTOM.BWA_OTP_AUTOFILL_CODE,
            code: cred.code
          }, _this6.bwaOrigin);
        }
      })["catch"](function () {/* aborted or unsupported — shopper types manually */});
    }
  }, {
    key: "cancelOtpAutofill",
    value: function cancelOtpAutofill() {
      if (this.otpAbortController) {
        try {
          this.otpAbortController.abort();
        } catch (e) {/* no-op */}
        this.otpAbortController = null;
      }
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      this.cancelOtpAutofill();
      this.removeEmbeddedCheckoutWidget();
      window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_EMBEDDED_CHECKOUT_DISMISS));
    }
  }, {
    key: "removeEmbeddedCheckoutWidget",
    value: function removeEmbeddedCheckoutWidget() {
      this.cancelOtpAutofill();
      var container = (0, _utils.safeGetElementById)(_constants.BWA_WIDGET_CONTAINER_IDS.BWA_EMBEDDED_CHECKOUT_CONTAINER_ID);
      if (container) container.remove();
      this.iframe = null;
      if (this.historyTrapArmed) {
        window.removeEventListener("popstate", this.handlePopState);
        this.historyTrapArmed = false;
      }
      document.body.classList.remove("bwa-no-scroll");
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-embedded-checkout-render-handler.js.map
